module.exports = __webpack_public_path__ + "static/media/emptyImageIcon.1c12aac7.svg";